import type { IconNames } from '@repo/foundations';
import type { ColorNames } from '@repo/theme/utils';

export const TEAM_ACCESS_REQUEST_CREATED_EVENT = 'team_access_request_created';
export const TEAM_ACCESS_REQUEST_APPROVED_EVENT =
	'team_access_request_approved';
export const TEAM_ACCESS_REQUEST_REJECTED_EVENT =
	'team_access_request_rejected';

export const TEAM_ACCESS_REQUEST_EVENTS = new Set([
	TEAM_ACCESS_REQUEST_CREATED_EVENT,
	TEAM_ACCESS_REQUEST_APPROVED_EVENT,
	TEAM_ACCESS_REQUEST_REJECTED_EVENT,
]);

export function isTeamAccessRequestEvent(event: string): boolean {
	return TEAM_ACCESS_REQUEST_EVENTS.has(event);
}

export function formatTeamAccessRequestTeamName(teamName: string): string {
	return /team$/i.test(teamName) ? teamName : `${teamName} team`;
}

export interface TeamAccessRequestStatusDisplay {
	label: 'Open' | 'Accepted' | 'Denied';
	iconName: IconNames;
	color?: ColorNames;
	fillColor?: ColorNames;
}

export function getTeamAccessRequestStatusDisplay(
	event: string,
	metadataStatus?: string
): TeamAccessRequestStatusDisplay {
	if (
		metadataStatus === 'approved' ||
		event === TEAM_ACCESS_REQUEST_APPROVED_EVENT
	) {
		return {
			label: 'Accepted',
			iconName: 'circleCheckFilled',
			color: 'icon/success/default',
			fillColor: 'icon/success/default',
		};
	}

	if (
		metadataStatus === 'rejected' ||
		event === TEAM_ACCESS_REQUEST_REJECTED_EVENT
	) {
		return {
			label: 'Denied',
			iconName: 'circleXFilled',
			color: 'icon/primary/disabled',
			fillColor: 'icon/primary/disabled',
		};
	}

	return {
		label: 'Open',
		iconName: 'clock',
		color: 'icon/info/default',
	};
}
